import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class PriceDataProxy extends ProxyBase {
  getPriceData(data, source) {
    return this.get('GetPriceData', data, source);
  }

  getLatestPrice(data) {
    return this.get('GetLatestPrice', data);
  }

  downloadPriceData(params) {
    return this.get('DownloadPriceData', params, null, 'download');
  }
}

const priceDataProxy = new PriceDataProxy(
  ServiceProxyConfig.Prices.PriceDataUrl,
);
export default priceDataProxy;
